module.exports = __webpack_public_path__ + "q.no1.0409e56e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/q.no1.jpg
// module id = 3Cyr
// module chunks = 0